import { Component, Input } from '@angular/core';
import { DisplayPropertyParams } from '../display-property/display-property.component';
import { Location } from 'src/app/core/models/project/location.model';
import { Property } from 'src/app/core/models/project/property.model';
import { FANCOIL_MODE_SHOW_STATUS_MANUAL } from 'src/environments/environment';

@Component({
  selector: 'app-display-fancoil-mode-in-room-overview',
  templateUrl: './display-fancoil-mode-in-room-overview.component.html',
  styleUrl: './display-fancoil-mode-in-room-overview.component.scss'
})
export class DisplayFancoilModeInRoomOverviewComponent {
  @Input({required:true}) location: Location;
  @Input({required:true}) propToDisplay: DisplayPropertyParams;
  @Input({required:true}) displaySize: string;
  @Input({required:true}) updated : Date;
  FANCOIL_MODE_SHOW_STATUS_MANUAL = FANCOIL_MODE_SHOW_STATUS_MANUAL;
  Property = Property;
  text = 'Fancoil mode';
}
